module.exports = __webpack_public_path__ + "static/media/login.dfa03c58.svg";